/*********
 Header Sticky
 **********/

/*********
 Header Dropdown
 **********/

document.querySelector('.headerBodyNavDrop')?.addEventListener('mouseover', function () {
    // show dropdown
    document.querySelector('.headerBodyNavExpand').classList.add('active');

    // change color of links
    document.querySelector('.headerBodyNavDrop').classList.add('active');
    document.querySelectorAll('.headerBodyNavLink').forEach(function (element) {
        element.classList.add('active');
    });

    // add listener to check if cursor leaves menu
    document.querySelector('.headerBodyNavExpand').addEventListener('mouseleave', function () {

        // hide dropdown
        document.querySelector('.headerBodyNavExpand').classList.remove('active');

        // change color of links
        document.querySelector('.headerBodyNavDrop').classList.remove('active');
        document.querySelectorAll('.headerBodyNavLink').forEach(function (element) {
            element.classList.remove('active');
        });
    });
});

// once user has scrolled 80px, change header styling
window.onscroll = function () {
    // some pages need to be overridden and be black the entire time
    if (document.querySelector("#header").classList.contains("override")) {
        return;
    }
    if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
        document.querySelector("#header").classList.add("active");
    } else {
        document.querySelector("#header").classList.remove("active");
    }
};

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector('#sliderContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector('#sliderContent').classList.remove('active');
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");

    // Wait before closing - allows animation to complete
    setTimeout(function () {
        document.querySelector("#slider").close();
    }, 400);
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));